/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react'
import { ContentComponentType } from '@splunk-iteng/splunk-shared-components/dist/lib/Types/ContentComponentType'
import { useIssuePasswordResetEmailMutation } from '../../graphql/graphql'

export function PasswordResetEmail({
  doSubmit,
  currentState,
  clearState
}: ContentComponentType) {
  const [email, setEmail] = useState(currentState?.email)
  const [localDoSubmit, setLocalDoSubmit] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [successData, setSuccessData] = useState({} as any)
  const [issuePasswordResetEmailMutation] = useIssuePasswordResetEmailMutation()
  const [emailHasChanged, setEmailHasChanged] = useState(false)

  useEffect(() => {
    if (currentState.email !== email) {
      setEmail(currentState.email)
      setEmailHasChanged(true)
    }
  }, [email, currentState.email])

  const submit = useCallback(async () => {
    try {
      if (emailHasChanged) {
        setSubmitted(false)
        setSubmitting(true)
        const { data }: any = await issuePasswordResetEmailMutation({
          variables: {
            username: email
          },
          onError: (err) => {
            const message = err.message.search('Must be in email format')
            if (message >= 0) {
              alert('Please provide a value with a valid email format')
            } else {
              alert(err.message)
            }
          }
        })
        setSubmitting(false)
        setSuccessData(data.issuePasswordResetEmail)
        setSubmitted(true)
      }
    } catch (error) {
      setSuccessData({})
      setSubmitting(false)
      setSubmitted(true)
    } finally {
      clearState()
    }
  }, [email, emailHasChanged, issuePasswordResetEmailMutation, clearState])

  const btn = (label = 'Send password reset email') => (
    <button
      type="button"
      className="mt-20 btn btn-primary"
      onClick={submit}
      disabled={submitting || !email}
    >
      {label}
    </button>
  )

  useEffect(() => {
    if (doSubmit && !localDoSubmit) {
      setLocalDoSubmit(true)
      submit()
    }
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit, submit])

  useEffect(() => {
    if (!doSubmit) setLocalDoSubmit(false)
  }, [doSubmit, localDoSubmit])

  if (submitting) {
    return <div className="pt-20">Sending password reset email...</div>
  }
  if (
    submitted &&
    email &&
    emailHasChanged &&
    (!successData || !successData.emailSent)
  ) {
    return (
      <div className="pt-20">
        Failed to send password reset email for {email}
        <br />
        {btn('Retry')}
      </div>
    )
  }
  if (submitted && successData && successData.emailSent) {
    return (
      <>
        <div>{btn('Send another password reset email')}</div>
        <div className="row pt-20">
          <div className="col-12">
            User {email} password reset email was successfully sent.
            <br />
            <h2 className="mt-20 uppercase">
              User Status: <span>{successData.userType}</span>
            </h2>
          </div>
        </div>
      </>
    )
  }
  return (
    <div className="pt-20">
      Please enter username to send a password reset email.
      <br />
      {btn()}
    </div>
  )
}
